import {ChangeDetectionStrategy, Component, ViewChild} from '@angular/core';
import {ApTraceLogActionsComponent}                    from './ap-trace-log-actions.component';
import {ApTraceLogBackendComponent}                    from './ap-trace-log-backend.component';
import {ApTraceLogClientComponent}                     from './ap-trace-log-client.component';
import {ApSectionHeaderGridComponent}                  from '../../../ap-section-header/components/ap-section-header-grid/ap-section-header-grid.component';
import {MapViewStore}                                  from '../../../stores/layout/mapview.store';
import {StatisticStore}                                from '../../../stores/statistic/statistic.store';

export enum TraceLogTabs {
  Actions = 0,
  Backend = 1,
  Client = 2
}

@Component({
  selector: 'ap-trace-log',
  templateUrl: 'ap-trace-log.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ApTraceLogComponent {

  @ViewChild(ApTraceLogActionsComponent, {static: false})
  public traceLogActionsComponent: ApTraceLogActionsComponent;

  @ViewChild(ApTraceLogClientComponent, {static: false})
  public traceLogClientComponent: ApTraceLogClientComponent;

  @ViewChild(ApSectionHeaderGridComponent, {static: false})
  private headerComponent: ApSectionHeaderGridComponent;

  public selectedTab: TraceLogTabs = TraceLogTabs.Actions;

  constructor(private mapViewStore: MapViewStore,
              private statisticStore: StatisticStore) {
    this.mapViewStore.goIntoStatisticMenu();
  }

  public selectTab(e): void {
    this.headerComponent.reset();
    this.statisticStore.removeStatisticData();
    switch (this.selectedTab) {
      case TraceLogTabs.Actions:
        this.traceLogActionsComponent.dynComponent?.dynGrid?.filterGrid('');
        break;
      case TraceLogTabs.Client:
        this.traceLogClientComponent.dynComponent?.dynGrid?.filterGrid('');
        break;
    }
    this.selectedTab = e.index;
  }

  public searchIn(value: string): void {
    switch (this.selectedTab) {
      case TraceLogTabs.Actions:
        this.traceLogActionsComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case TraceLogTabs.Client:
        this.traceLogClientComponent.dynComponent?.dynGrid?.filterGrid(value);
        break;
    }
  }
}
